import { render, staticRenderFns } from "./mo-account-panel.html?vue&type=template&id=cd702c96&scoped=true&external"
import script from "./mo-account-panel.ts?vue&type=script&lang=ts&external"
export * from "./mo-account-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-account-panel.vue?vue&type=style&index=0&id=cd702c96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd702c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd702c96')) {
      api.createRecord('cd702c96', component.options)
    } else {
      api.reload('cd702c96', component.options)
    }
    module.hot.accept("./mo-account-panel.html?vue&type=template&id=cd702c96&scoped=true&external", function () {
      api.rerender('cd702c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-account-panel/mo-account-panel.vue"
export default component.exports